import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOrderFundingAttachments(orderId) {
  const response = await $.soap({
    body: {
      GetOrderFundingAttachments: {
        $xmlns: 'http://dla.mil/ems/bpm/attachment',
        OrderID: orderId
      }
    },
    blueprintArrays: ['GetOrderFundingAttachmentsResponse.Attachments.Attachment'],
    blueprint: {
      attachments: [
        '$..Attachment',
        {
          id: '$..ID',
          objectTypeId: '$..ObjectTypeID',
          objectId: '$..ObjectID',
          documentTypeId: '$..DocumentTypeID',
          fileName: '$..FileName',
          uploadedBy: '$..UploadedBy',
          uploadedOn: '$..UploadedOn'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.attachments;
}
